<template>
  <div class="h-outTabs">
    <ejs-tab ref="tabObj" heightAdjustMode="Auto" :selecting="disableSelecting">
      <div class="e-tab-header">
        <div>{{$t('Security.userInfo')}}</div>
        <div>{{$t('Security.group.name')}}</div>
        <div>{{$t('Security.timeStrategy')}}</div>
      </div>
      <div class="e-content">
        <div id="account_tab1" style="display: none">
          <AccountBase ref="editBase" :baseType="baseType" :formId="formId"></AccountBase>
        </div>
        <div id="account_tab2" style="display: none">
          <AccountGroup ref="editRole"></AccountGroup>
        </div>
        <div id="account_tab3" style="display: none">
          <AccountStrategy ref="editStrategy"></AccountStrategy>
        </div>
      </div>
    </ejs-tab>
  </div>
</template>
<script>
import AccountBase from './accountBase';
import AccountGroup from './accountGroup';
import AccountStrategy from './accountStrategy';
import { EventBus } from "../../../plugins/eventBus";

export default {
  name: 'EditAccount',
  components: {
    AccountBase,
    AccountGroup,
    AccountStrategy
  },
  data() {
    return {
      baseType: 1,
      formId: 'editBaseForm',
      userId: ''
    };
  },
  methods: {
    findEditAccount(editId) {
      this.$refs.editBase.init();
      this.userId = editId;
      const baseUrl = '/lte/ems/user/findOne';
      const params = { params: {
        userId: editId
      } };
      const That = this;
      this.axios.get(baseUrl, params).then(response => {
        const result = response.data;
        That.account = result;
        That.$refs.editBase.setbaseInfo(result);
        this.$refs.editStrategy.init(That.account.timeStrategyId);
        this.$refs.editRole.init(That.account.groupIdList);
        this.$refs.editRole.getRoleList();
        this.$refs.editStrategy.getStrategyList();
      });
    },
    getEditInfo() {
      let base_v_status = this.$refs.editBase.validateAccountBase();
      if(base_v_status) {
        const account = this.$refs.editBase.getAccountBase();
        account['userId'] = this.userId;
        const selected = this.$refs.editRole.getSelectRole();
        // if(selectedRole != null && selectedRole != '') {
        //   const roleIds = []
        //   selectedRole.forEach((role) => {
        //     roleIds.push(role.roleId);
        //   })
        //   account['roleIdList'] = roleIds;
        // }
        if(selected != null && selected != '') {
          const groupIds = []
          selected.forEach((item) => {
            groupIds.push(item.groupId);
          })
          account['groupIdList'] = groupIds;
        }
        const selectedStrategy = this.$refs.editStrategy.getSelectStrategy();
        if(selectedStrategy != null && selectedStrategy != '') {
          account['timeStrategyId'] = selectedStrategy[0].strategyId;
        }else {
          EventBus.$emit('toast', {type: 'warning', content:  `${this.$t('Security.selectTimePolicy')}`});
          return null;
        }
        return account;
      }
    },
    disableSelecting(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    }
  }
};
</script>
